<template>
    <div class="invalid-feedback" role="alert">
        <slot/>
    </div>
</template>
